import { PROTOCOL, WWWHost, requestWrap, formPost } from "./config";

export const fetchListApi = params => {
  var queryParams = "";
  if (params.tags && params.tags.length > 0) {
    queryParams = `published=${params.published}&sort=${params.sort}&tags[]=${params.tags}&keyword=${params.keyword}&page=${params.page}&per=${params.per}`;
  } else {
    if (params.keyword) {
      queryParams = `published=${params.published}&sort=${params.sort}&keyword=${params.keyword}&page=${params.page}&per=${params.per}`;
    } else {
      queryParams = `page=${params.page}&per=${params.per}`;
    }
  }

  return requestWrap(
    `${PROTOCOL}//${WWWHost}/api/article_library/articles.json?${queryParams}`,
    {}
  );
};

export const fetchArticleApi = id => {
  return requestWrap(
    `${PROTOCOL}//${WWWHost}/api/article_library/articles/${id}`,
    {}
  );
};

export const fetchGraphApi = (type, id) => {
  return requestWrap(`${PROTOCOL}//${WWWHost}/graph/${type}/${id}.json`, {});
};

export const updateLike = (id, liked) => {
  return formPost(
    !liked
      ? `${PROTOCOL}//${WWWHost}/articles/${id}/like`
      : `${PROTOCOL}//${WWWHost}/articles/${id}/dislike`,
    {}
  );
};

// 商品信息
export const fetchProductApi = (id: string) => {
  return requestWrap(
    `${PROTOCOL}//${WWWHost}/api/article_library/article_orders/product.json`,
    { id }
  );
};

// 创建订单
export const createPayOrderApi = (ArticleProductId: string) => {
  return requestWrap(
    `${PROTOCOL}//${WWWHost}/api/article_library/article_orders`,
    {
      ArticleProductId,
    },
    "POST"
  );
};

// 获取订单参数给微信
export const fetchPayInfoApi = (orderId: string) => {
  return requestWrap(
    `${PROTOCOL}//${WWWHost}/api/article_library/article_orders/get_wechat_qr`,
    {
      orderId,
    }
  );
};

// 获取支付二维码
export const fetchPayCodeApi = (orderId: string) => {
  return requestWrap(
    `${PROTOCOL}//${WWWHost}/api/article_library/article_orders/pc_get_wechat_qr`,
    {
      orderId,
    }
  );
};

//  获取订单支付状态
export const fetchWxPayStatusApi = (orderId: string) => {
  return requestWrap(
    `${PROTOCOL}//${WWWHost}/api/article_library/article_orders/order_poll`,
    {
      orderId,
    }
  );
};

// 获取会员信息
export const fetchMemberInfoApi = () => {
  return requestWrap(
    `${PROTOCOL}//${WWWHost}/api/article_library/articles/member_info.json`,
    {}
  );
};
